import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class PreviewService {



  // private ip = 'http://35.232.140.117:3800';

  constructor(
    private httpClient: HttpClient
  ) { }




  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }


  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }

}
